// extracted by mini-css-extract-plugin
export var container = "_bn-0";